import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Vision from './pages/Vision';
import Contact from './pages/Contact';
import Newsletter from './pages/NewsLetter';
import FAQ from './pages/FAQ';
import Blog from './pages/Blog';
import Services from './pages/Services';
import ScrollToTop from './components/ScrollToTop';
import ServiceDetail from './pages/services/ServiceDetail';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ClientServiceGuide from './pages/resources/CandidateHandbook';
import Roadmap from './pages/Roadmap';

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/vision" element={<Vision />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/resources/candidatehandbook" element={<ClientServiceGuide />} />
          <Route path="/roadmap" element={<Roadmap />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;